import { FC } from "react";
import { Box, Group, Switch, Text } from "@mantine/core";
import { FilterComponentProps } from ".";
import { SPECIALTY_COLOR_MAP } from "../consts";

const SpecialtyTypeFilter: FC<FilterComponentProps> = ({
  onFilterControlChange,
  filterControl
}) => {
  return (
    <Box mt="xl" ml={10} mr={5} h="85%" style={{overflowY: "scroll"}}>
      <Switch.Group
        value={filterControl?.specialtyType || undefined}
        onChange={(v) => onFilterControlChange({
          ...filterControl,
          specialtyType: v,
        })}>
      {Array.from(SPECIALTY_COLOR_MAP.keys()).map((specialty, index) => (
        <Group justify="space-between" my="sm" key={index}>
          <Text fz="sm" fw="bold">
            {specialty}
          </Text>
          <Switch
            value={specialty}
           />
        </Group>
      ))}
      </Switch.Group>
    </Box>
  );
};

export default SpecialtyTypeFilter;